/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";

const FilterIconSelectedV2 = (props) => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M1.5102 4.67501C3.45288 7.15834 6.32504 10.8333 6.32504 10.8333V15C6.32504 15.9167 7.07867 16.6667 7.99977 16.6667C8.92087 16.6667 9.6745 15.9167 9.6745 15V10.8333C9.6745 10.8333 12.5467 7.15834 14.4893 4.67501C14.9164 4.12501 14.5228 3.33334 13.8195 3.33334H2.17172C1.4767 3.33334 1.08314 4.12501 1.5102 4.67501Z"
			fill="#190A28"
		/>
		<rect
			x="11"
			y="1"
			width="6"
			height="6"
			rx="3"
			fill="#CB2F4B"
			stroke="white"
			strokeWidth="2"
		/>
	</svg>
);
export default FilterIconSelectedV2;
